import { WHATSAPP_LINK } from "@/config";
import { MessageCircle } from "lucide-react";

const WhatsAppFloat = () => (
  <a
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat with us on WhatsApp"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-4 text-white shadow-lg shadow-black/10 transition-transform duration-300 hover:-translate-y-1"
  >
    <MessageCircle className="w-6 h-6" />
    <span className="hidden sm:inline font-medium">Chat with us</span>
  </a>
);

export default WhatsAppFloat;
